import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { deleteSupplierApi, fetchSuppliersApi, saveSupplierApi } from './suppliers.api';
import {
  deleteSupplierFailure,
  deleteSupplierRequest,
  deleteSupplierSuccess,
  fetchSuppliersFailure,
  fetchSuppliersRequest,
  fetchSuppliersSuccess,
  saveSupplierFailure,
  saveSupplierRequest,
  saveSupplierSuccess,
  toggleSupplierActiveFailure,
  toggleSupplierActiveRequest,
  toggleSupplierActiveSuccess,
} from './suppliers.slice';

import { Supplier } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchSuppliersSaga(action: PayloadAction<any | undefined>): Generator<any, void, any> {
  try {
    const response: { items: Supplier[]; totalCount: number } = yield call(fetchSuppliersApi, action.payload);
    yield put(fetchSuppliersSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchSuppliersFailure, 'Failed to fetch suppliers');
  }
}

function* saveSupplierSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield call(saveSupplierApi, action.payload as Supplier);
    yield put(saveSupplierSuccess());
    toast.success('Supplier saved successfully');
    yield put(fetchSuppliersRequest({ searchCriteria: { pageSize: 20, currentPage: 1 } }));
  } catch (error: any) {
    yield handleSagaError(error, saveSupplierFailure, 'Failed to save supplier');
  }
}

function* deleteSupplierSaga(action: PayloadAction<number>): Generator<any, void, any> {
  try {
    yield call(deleteSupplierApi, action.payload);
    yield put(deleteSupplierSuccess());
    toast.success('Supplier deleted successfully');
    yield put(fetchSuppliersRequest({ searchCriteria: { pageSize: 20, currentPage: 1 } }));
  } catch (error: any) {
    yield handleSagaError(error, deleteSupplierFailure, 'Failed to delete supplier');
  }
}

function* toggleSupplierActiveSaga(action: PayloadAction<Supplier>): Generator<any, void, any> {
  try {
    yield call(saveSupplierApi, action.payload);
    yield put(toggleSupplierActiveSuccess(action.payload));
  } catch (error: any) {
    yield handleSagaError(error, toggleSupplierActiveFailure, 'Failed to update supplier status');
  }
}

export default function* suppliersSaga() {
  yield takeLatest(fetchSuppliersRequest.type, fetchSuppliersSaga);
  yield takeLatest(saveSupplierRequest.type, saveSupplierSaga);
  yield takeLatest(deleteSupplierRequest.type, deleteSupplierSaga);
  yield takeLatest(toggleSupplierActiveRequest.type, toggleSupplierActiveSaga);
}
